import React, { useState, useEffect } from "react";
import AddIcon from "@material-ui/icons/Add";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { Box, Checkbox, Grid, Typography } from "@material-ui/core";
import axios from "../../../../services/auth/jwt/config";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "80%",
    marginInline: "auto",
    height: "43px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    borderBottomWidth: "1px",
    borderBottomStyle: "solid",
    borderBottomColor: theme.palette.grey[400],
  },
  icon: {
    color: theme.palette.grey[400],
    marginRight: "10px",
  },
  titleContainer: {
    display: "flex",
  },
  title: {
    color: theme.palette.grey[600],
    fontWeight: "bold",
  },
}));

export default function AccessCheckElement({ itemName, itemVal }) {
  const [hasAccess, setHasAccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const { id } = useParams();

  const checkHasAccess = () => {
    setLoading(true);
    axios
      .post("/adminAccess/getAdminAccess", {
        type: itemVal,
        owner: id,
      })
      .then(({ data }) => {
        setHasAccess(data.typeAccess);
        setLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    checkHasAccess();
  }, []);

  const handgeChangeAccess = (access) => {
    if (access) {
      setLoading(true);
      axios
        .post("/adminAccess/create", {
          type: itemVal,
          owner: id,
        })
        .then(() => {
          setHasAccess(true);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    } else {
      setLoading(true);
      axios
        .post("/adminAccess/delete", {
          type: itemVal,
          owner: id,
        })
        .then(() => {
          setHasAccess(false);
          setLoading(false);
        })
        .catch((error) => {
          console.log(error);
          setLoading(false);
        });
    }
  };

  const classes = useStyles();
  return (
    <Grid item xs={12} md={6}>
      <Box className={classes.container}>
        <Box className={classes.titleContainer}>
          <AddIcon className={classes.icon} />
          <Typography className={classes.title}>{itemName}</Typography>
        </Box>
        {!loading && (
          <Checkbox
            checked={hasAccess}
            onChange={(e) => handgeChangeAccess(e.target.checked)}
            color="primary"
          />
        )}
      </Box>
    </Grid>
  );
}
